import { includes } from "lodash/fp";
import { borderColor, borderWidth } from "polished";
function createTriangleStyles({
  color,
  justify,
  offset = "50%",
  placement,
  size
}) {
  if (!includes(placement, ["top", "right", "bottom", "left"])) {
    throw new Error(
      "createTriangleStyles: `placement` field must be one of `top`, `bottom`, `left`, `right`"
    );
  }
  const end = (() => {
    if (placement === "left" || placement === "right") {
      return justify === "end" ? "bottom" : "top";
    }
    return justify === "end" ? "right" : "left";
  })();
  return {
    ...borderColor(
      placement === "top" ? color : "transparent",
      placement === "right" ? color : "transparent",
      placement === "bottom" ? color : "transparent",
      placement === "left" ? color : "transparent"
    ),
    borderStyle: "solid",
    ...borderWidth(
      placement === "bottom" ? 0 : size,
      placement === "left" ? 0 : size,
      placement === "top" ? 0 : size,
      placement === "right" ? 0 : size
    ),
    content: '""',
    [end]: offset,
    height: 0,
    [placement]: "100%",
    position: "absolute",
    transform: placement === "left" || placement === "right" ? `translateY(${justify === "end" ? "50%" : "-50%"})` : `translateX(${justify === "end" ? "50%" : "-50%"})`,
    width: 0
  };
}
export {
  createTriangleStyles
};
